import { brandLink } from "../global/constants"
import { useTranslation } from "react-i18next";
// import facebookImg from '../assets/brand/facebook.png'
// import telegramImg from '../assets/brand/telegram.png'
// import twitterImg from '../assets/brand/twitter.png'
// import youtubeImg from '../assets/brand/youtube.png'
// import tiktokImg from '../assets/brand/tiktok.png'
// import discordImg from '../assets/brand/discord.png'
// import igImg from '../assets/brand/ig.png'
// import mediumImg from '../assets/brand/medium.png'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation,
  useNavigate
} from "react-router-dom";

import { useState } from 'react'


import facebookImg from '../assets/brand/facebook.png'
import youtubeImg from '../assets/brand/youtube.png'
import instagramImg from '../assets/brand/instagram.png'
import lineImg from '../assets/brand/line.png'

import { useSelector } from "react-redux";



const Footer = () => {
  const location = useLocation()
  const { t } = useTranslation();
  const navigate = useNavigate()
  const menuData = useSelector(state => state.menu);


  const [openMenuProductType, setOpenMenuProductType] = useState(false)


  let linkList = [
    {
        link: "https://lin.ee/QicbUjW",
        img: lineImg,
    },
    {
        link: "https://www.facebook.com/profile.php?id=100093667357708",
        img: facebookImg,
    },
    {
        link: "https://www.youtube.com/channel/UCLNIP64iKNi1pxeSsmfsgSQ",
        img: youtubeImg,
    },
    {
        link: "https://www.instagram.com/alphamars.co/",
        img: instagramImg,
    },
]


  function navigatePath(path) {
    navigate(path)
    setOpenMenuProductType(false)
    window.scroll(0, 0)


  }

  return location.pathname != '/' && <div className="w-full bg-black text-white leading-">
    <div className=" justify-center flex  flex-wrap  gap-y-[40px] max-w-[1000px] w-full py-[100px] mx-auto  ">


      <div className="w-[50%] sm:w-[33%] px-4 sm:px-10 ">
        <p className=" font-bold text-lg mb-5">產品服務</p>
        <div className="bg-white opacity-70 w-10/12 h-px mb-6"></div>
        <div className={`relative  mb-4`} >
          <button onClick={() => setOpenMenuProductType(!openMenuProductType)} className={`  hover:text-red1  flex justify-start items-center cursor-pointer   `}>產品分類</button>
          {
            menuData && openMenuProductType &&
            <div className=" bg-black bg-opacity-[0.85]  w-full  flex pb-[10px]">
              <div className="w-full ">
                {
                  menuData.map((i, index) => <div onClick={() => navigatePath('/producttype?categoryId=' + i.id)} key={index} className={` hover:bg-red1 hover:text-black99 text-white cursor-pointer text-sm flex justify-between items-center px-1 py-3  font-bold w-full`}>
                    <p>{i.name}</p>

                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                      <path d="M8.33333 14.6668L12.5 10.5002L8.33333 6.3335" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                  </div>)
                }
              </div>


            </div>
          }
        </div>


        <button onClick={() => navigate('/contactus')} className="hover:text-red1 mb-4">聯絡我們</button><br />
      </div>

      <div className="w-[50%] sm:w-[33%] px-4 sm:px-10">
        <p className=" font-bold text-lg mb-5">會員服務</p>
        <div className="bg-white opacity-70 w-10/12 h-px mb-6"></div>
        <button onClick={() => navigate('/membercenter')} className="hover:text-red1 mb-4">會員中心</button><br />
        <button onClick={() => navigate('/membercenter/message')} className="hover:text-red1 mb-4">訊息中心</button><br />
        <button onClick={() => navigate('/cart')} className="hover:text-red1 mb-4">購物車</button>
        <div className="mb-4">
          <a className="hover:text-red1 " href="https://docs.google.com/forms/d/e/1FAIpQLScG9DVk4bRMKUjY_eMqrcsVVfiMGoZA_e6uGIDlBoNNmsGDXw/viewform" target="_blank">經銷商報名線上表單</a>
        </div>
        <div>
          <a className="hover:text-red1 mb-4" href="https://docs.google.com/forms/d/e/1FAIpQLSeqH2PNVNMhbXNPO8yFWFGfsFXfWiMUEXgQAGEBZsj4bdtQxA/viewform" target="_blank">活動滿意度回饋調查表單</a>
        </div>
      </div>


      <div className="w-auto sm:w-[33%] px-4 sm:px-10">


        <p className=" font-bold text-lg text-center sm:text-left mb-4">加入社群</p>
        <div className="flex gap-4 flex-col">
          <div className="flex  gap-2 sm:gap-3 justify-center sm:justify-start items-center">
            {
              linkList.slice(0,2).map((i, index) => <a href={i.link} target="_blank"><div className={`bg-main1 w-10  aspect-[1/1] rounded-full ${index != 1 ? `p-[6px]` : 'pt-[2px] '}`}>
                <img src={i.img} />
              </div>
              </a>)
            }
          </div>
          <div className="flex  gap-2 sm:gap-3 justify-center  sm:justify-start items-center">
            {
              linkList.slice(2,4).map((i, index) => <a href={i.link} target="_blank"><div className={`bg-main1 w-10  aspect-[1/1] rounded-full ${index != 1 ? `p-[6px]` : 'p-[6px] '}`}>
                <img src={i.img} />
              </div>
              </a>)
            }
          </div>

        </div>
      </div>

    </div>

  </div>

}
export default Footer